var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0409 19.0412H16.0776V14.4003C16.0776 13.2937 16.0578 11.8691 14.5363 11.8691C12.9929 11.8691 12.7567 13.0748 12.7567 14.3198V19.0408H9.79344V9.49741H12.6382V10.8016H12.678C12.9627 10.3148 13.3741 9.91437 13.8684 9.64289C14.3627 9.37141 14.9214 9.23908 15.4849 9.25999C18.4884 9.25999 19.0422 11.2356 19.0422 13.8058L19.0409 19.0412ZM6.44969 8.19296C5.49992 8.19311 4.72984 7.42327 4.72969 6.4735C4.72953 5.52374 5.4993 4.75366 6.44906 4.7535C7.39883 4.75327 8.16891 5.52311 8.16906 6.47288C8.16915 6.92898 7.98805 7.36643 7.6656 7.689C7.34316 8.01158 6.90578 8.19285 6.44969 8.19296ZM7.93141 19.0412H4.96492V9.49741H7.93133V19.0412L7.93141 19.0412ZM20.5183 2.00139H3.47586C2.67039 1.99233 2.00984 2.63757 2 3.44304V20.5565C2.00953 21.3624 2.67 22.0083 3.47578 21.9998H20.5183C21.3258 22.0098 21.9888 21.364 22 20.5565V3.44171C21.9885 2.63468 21.3254 1.98952 20.5183 2.00007",
    fill: "#0A66C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInMobile);
export default __webpack_public_path__ + "static/media/linkedIn-mobile.2ecba794948e3b2fdc7963a920e7594e.svg";
export { ForwardRef as ReactComponent };